import React, { useContext, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import Select from "react-select";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import { currentDateAndTime} from "../../Constants/Constants";
import { SubmitButton } from "../../Components/InputElements";
import { date } from "yup";

const GeneralSettings = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const [loading, setLoading] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [leaveTypeId, setLeaveTypeId] = useState("");
    const [leaveOptions, setLeaveOptions] = useState([]);
    const [empOptions, setEmpOptions] = useState([]);
    const [empkeyword, setEmpkeyword] = useState("");
    const [errors, setErrors] = useState({})
    const monthOptions = [
        { value: 1, label: "1 Month" },
        { value: 2, label: "2 Month" },
        { value: 3, label: "3 Month" },
        { value: 4, label: "4 Month" },
        { value: 5, label: "5 Month" },
        { value: 6, label: "6 Month" },
        { value: 7, label: "7 Month" },
        { value: 8, label: "8 Month" },
        { value: 9, label: "9 Month" },
        { value: 10, label: "10 Month" },
        { value: 11, label: "11 Month" },
        { value: 12, label: "12 Month" },
    ];
    const [formData, setFormData] = useState({
        company_id: 0,
        company_setting_id: 0,
        notice_period_duration: "0",
        company_employee_login_type : "1",
        company_employee_payslip_password_protected : "0",
        notification_goes_to:"",
        get_noc_from: "",
        date: currentDateAndTime()
    });
    const [isChanged, setIsChanged] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);

    const balanceCarriedForwardNumberRef = useRef(null);
    const leaveApplicableAfterRef = useRef(null);
    const futureDaysToApplyLeaveRef = useRef(null);
    const minConsecutiveLeaveDaysRef = useRef(null);
    const maxConsecutiveLeaveDaysRef = useRef(null);
    useEffect(() => {
        if (errors?.balanceCarriedForwardNumber) {
            balanceCarriedForwardNumberRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            balanceCarriedForwardNumberRef.current?.focus(); // Optional: To focus the input as well
        }
        if (errors?.leaveApplicableAfter) {
            leaveApplicableAfterRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (errors?.futureDaysToApplyLeave) {
            futureDaysToApplyLeaveRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            futureDaysToApplyLeaveRef.current?.focus();
        }
        if (errors?.minConsecutiveLeaveDays) {
            minConsecutiveLeaveDaysRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            minConsecutiveLeaveDaysRef.current?.focus();
        }
        if (errors?.maxConsecutiveLeaveDays) {
            maxConsecutiveLeaveDaysRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            maxConsecutiveLeaveDaysRef.current?.focus();
        }
    }, [errors]);

    const getCompanies = () => {
        const headers = apiHeaderJson;
        // console.log("headers =>",headers);
        axios.get(`${apiURL}CompanyMasters/getCompanies`, {
            params: {
            }, headers
        }).then((response) => {
            let data = response.data;
            // console.log(data);
            if (response.data.success === true) {
                let rows = data?.companies?.map((val,idx) => {
                    return  { value: val?.company_id, label: val?.company_name }
                });
                setCompanyOptions(rows);
                
            } else {
                console.error("Error fetching list");
            }
        }).catch((error) => {
            console.error("error", error);
        });
    }

    const getEmployeesOptionList = (e) => {
          const headers = apiHeaderJson;
          try {
            axios
              .get(`${apiURL}Masters/GetCompanyEmployeesList`, { params: { keyword: '' }, headers })
              .then((response) => {
                if (response.data.success === true) {
                  setEmpOptions( response.data.data );
                  console.log(response.data.data);
                } else {
                  setEmpOptions([]);
                }
              })
          } catch (error) {
            console.error("error", error)
          }
    }

    useEffect(() => {
        getCompanies();
        // getInfo();
        // getEmployeesOptionList();
    }, []);
    useEffect(() => {
        if(isChanged){
            getInfo();
            setIsChanged(false);
        }
    }, [isChanged]);

    const getInfo = () => {
        const headers = apiHeaderJson;
        setLoading(true);
        axios
            .get(
                `${apiURL}Companies/GetGeneralSettings`,
                {
                params:{
                    company_id: formData?.company_id,
                },
                headers }
            )
            .then((response) => {
                const { success } = response.data;
                console.info("GetGeneralSettings ~ response", response);
                if (success === true) {
                    let data = response.data;
                    setErrors({});
                    console.log(" data?.data[0]?.company_setting_id ",data?.data[0]?.company_setting_id );
                    setFormData({
                        ...formData,
                        company_setting_id: data?.data[0]?.company_setting_id || 0,
                        company_employee_login_type: data?.data[0]?.company_employee_login_type || "",
                        company_employee_payslip_password_protected: data?.data[0]?.company_employee_payslips_password_protected || "",
                    });
                } else if (success === false) {
                    setFormData({
                        ...formData,
                        company_setting_id: 0,
                        notice_period_duration: "0",
                        company_employee_login_type: "",
                        company_employee_payslip_password_protected: "",
                        notification_goes_to: "",
                        get_noc_from: "",
                        resignation_allowed_count: "",
                    });
                }
                setLoading(false);
            })
            .catch((error)=>{
                console.log("GetGeneralSettings ERROR: ", error);
                setLoading(false);
            });
        
    };


    const validateForm = () => {
        let errors = {}
        if (!formData?.notice_period_duration) {
            errors.notice_period_duration = "Notice period is required!"
        }
        if (!formData?.company_employee_login_type ) {
            errors.company_employee_login_type  = "This field is required!"
        }   
        if (!formData?.company_employee_payslip_password_protected ) {
            errors.company_employee_payslip_password_protected  = "This field is required!"
        }   
        return errors;

    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const errors = validateForm();
        console.error("errors", errors);
        if (Object.keys(errors).length > 0) {
            setErrors(errors);
            return;
        }

        const headers = apiHeaderJson;
        const data = {
            company_setting_id: formData?.company_setting_id || null,
            company_id: formData?.company_id,
            company_employee_login_type: formData?.company_employee_login_type,
            company_employee_payslips_password_protected: formData?.company_employee_payslip_password_protected,
            date: currentDateAndTime(),
        }
        
        console.log("handleSubmit ~ form Data =======>>>", data);
        Swal.fire({
              title: "Are you sure?",
              text: `You want to ${data?.company_setting_id? "update":"save"} general settings!`,
              icon: "warning",
              showCancelButton: true,
            //   confirmButtonColor: "#3085d6",
            //   cancelButtonColor: "#d33",
              confirmButtonText: "Yes!",
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                setPostLoading(true);
                axios
                    .post(`${apiURL}Companies/CreateUpdateGeneralSettings`, data, {
                        headers,
                    })
                    .then((response) => {
                        const { success } = response.data;
                        console.log("handleSubmit ~ response =======>>>", response);
                        if (success === true) {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {}
                            });
                            setPostLoading(false);
                            getInfo();
                        } else {
                            Swal.fire({
                                title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                                text: response.data.message,
                                icon: success ? 'success' : 'error',
                                showConfirmButton: true, 
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {}
                            });
                            setPostLoading(false);
                        }
                    })
                    .catch((error)=>{
                        console.error(error);
                        Swal.fire({
                                title: `<strong>Failed</strong>`,
                                text: "Opps...! Something went wrong.",
                                icon: 'error',
                                showConfirmButton: true, 
                                allowOutsideClick: false,
                            })
                        setPostLoading(false);
                    });
                }
            }
        );
    };

    const handleFormData = (name, value) => {
        // console.log("handleFormData", name, value);
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };
    const handleMultiSelect = (fieldName, selectedOptions) => {
        console.log("selectedOptions fieldName",fieldName, selectedOptions);
            const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
            setFormData(prevFormData => ({
                ...prevFormData,
                [fieldName]: ids.join(',')  
            }));
        // Clear the error message for componentLocation
        setErrors(prevErrors => ({
            ...prevErrors,
            [fieldName]: ''
        }));
    };
 
    const handleNumbers = (name, value) => {
        // console.log("isNumeric(value)",isNumeric(value),name, value);
    }

    console.log("LeaveTemplateSettings ~ formData", formData);

    return (
        <div>
            {!loading ? (
                <div class="main-content">
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`General Settings`} primary={`Home`} />
                            <div className="card">
                                <div className="card-header align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">
                                        General Settings
                                    </h4>
                                </div>
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="col-md-12">
                                            <form
                                                onSubmit={handleSubmit}
                                                className="row settings-form"
                                            >
                                                <div className=' col-md-6 position-relative mb-5'>
                                                    {/* <div className=" mx-3 mt-2 mb-1 "> */}
                                                        <label className="form-label" >Select Company</label>
                                                        <div className=' position-absolute z-2 w-100 pe-3' >
                                                            <Select
                                                                onChange={(selectedOption) => { setIsChanged(true); setFormData({ ...formData, company_id: selectedOption?.value });}}
                                                                placeholder={`Select Company`}
                                                                options={companyOptions}
                                                                value={formData?.company_id ? companyOptions.find(option => option.value == formData?.company_id) : null}
                                                            />
                                                        </div>
                                                        {/* {errors.company_id && <div className="text-danger">{errors.company_id}</div>} */}
                                                    {/* </div> */}
                                                </div>
                                                {/* Can HR/Admin edit last working date? */}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>How do you want to login company employee panel?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="company_employee_login_type_yes"
                                                            name="company_employee_login_type"
                                                            value="1"
                                                            checked={formData?.company_employee_login_type  === "1"}
                                                            onChange={() => handleFormData("company_employee_login_type", "1")}
                                                            className="form-check-input"
                                                            disabled={!formData?.company_id} 
                                                        />
                                                        <label
                                                            htmlFor="company_employee_login_type_yes"
                                                            className="form-check-label"
                                                        >
                                                            Password
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="company_employee_login_type_no"
                                                            name="company_employee_login_type"
                                                            value="2"
                                                            checked={formData?.company_employee_login_type  === "2"}
                                                            onChange={() => handleFormData("company_employee_login_type", "2")}
                                                            className="form-check-input"
                                                            disabled={!formData?.company_id} 
                                                        />
                                                        <label
                                                            htmlFor="company_employee_login_type_no"
                                                            className="form-check-label"
                                                        >
                                                            OTP
                                                        </label>
                                                    </div>
                                                    {errors?.company_employee_login_type  ?<div className=" text-danger">{errors?.company_employee_login_type }</div>: null}
                                                </div>
                                                {/*Should employees payslips be password-protected?*/}
                                                <div className="col-md-6 mt-4 settings-section">
                                                    <div>
                                                        <label>Should employees payslips be password-protected?</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="company_employee_payslip_password_protected_yes"
                                                            name="company_employee_payslip_password_protected"
                                                            value="1"
                                                            checked={formData?.company_employee_payslip_password_protected  === "1"}
                                                            onChange={() => handleFormData("company_employee_payslip_password_protected", "1")}
                                                            className="form-check-input"
                                                            disabled={!formData?.company_id} 
                                                        />
                                                        <label
                                                            htmlFor="company_employee_payslip_password_protected_yes"
                                                            className="form-check-label"
                                                        >
                                                            YES
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            type="radio"
                                                            id="company_employee_payslip_password_protected_no"
                                                            name="company_employee_payslip_password_protected"
                                                            value="2"
                                                            checked={formData?.company_employee_payslip_password_protected  === "0"}
                                                            onChange={() => handleFormData("company_employee_payslip_password_protected", "0")}
                                                            className="form-check-input"
                                                            disabled={!formData?.company_id} 
                                                        />
                                                        <label
                                                            htmlFor="company_employee_payslip_password_protected_no"
                                                            className="form-check-label"
                                                        >
                                                            NO
                                                        </label>
                                                    </div>
                                                    {errors?.company_employee_payslip_password_protected  ?<div className=" text-danger">{errors?.company_employee_payslip_password_protected }</div>: null}
                                                </div>
                                                {/* <button type='submit' >Save</button> */}
                                                <div style={{ marginTop: "30px", marginLeft: "Auto" }}>
                                                    {/* {!postLoading ? */}
                                                        {/* // <button
                                                        //     type="submit"
                                                        //     className={`btn btn-primary btn-label waves-effect waves-light float-right`}>
                                                        //     <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                        //     {formData?.company_setting_id==0?"Save":"Update"}
                                                        // </button> */}
                                                        <SubmitButton disabled={!formData?.company_id} 
                                                        loading={postLoading}
                                                        loadingMessage='Loading'
                                                        buttonName={formData?.company_setting_id==0 ? "Save" : "Update"} type='primary' icon='ri-save-line' />
                                                        {/* //  :
                                                        // <button
                                                        //     className={`btn btn-primary btn-label waves-effect right waves-light float-right`}>
                                                        //     <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />{" "}
                                                        //     {"Loading..."}
                                                        // </button>} */}
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
                        <div className="email-menu-sidebar">
                            <div className="p-4 d-flex flex-column h-100">
                            <div className="pb-4 border-bottom border-bottom-dashed">
                                <button type="button" className="btn btn-danger w-100" data-bs-toggle="modal" data-bs-target="#composemodal"><svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle icon-xs me-1 icon-dual-light"><circle cx={12} cy={12} r={10} /><line x1={12} y1={8} x2={12} y2={16} /><line x1={8} y1={12} x2={16} y2={12} /></svg> Compose</button>
                            </div>
                            <div className="mx-n4 px-4 email-menu-sidebar-scroll simplebar-scrollable-y" data-simplebar="init"><div className="simplebar-wrapper" style={{margin: '0px -24px'}}><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer" /></div><div className="simplebar-mask"><div className="simplebar-offset" style={{right: 0, bottom: 0}}><div className="simplebar-content-wrapper" tabIndex={0} role="region" aria-label="scrollable content" style={{height: '100%', overflow: 'hidden scroll'}}><div className="simplebar-content" style={{padding: '0px 24px'}}>
                                        <div className="mail-list mt-3">
                                            <a href="#" className="active"><i className="ri-mail-fill me-3 align-middle fw-medium" /> <span className="mail-list-link">All</span> <span className="badge bg-success-subtle text-success ms-auto  ">5</span></a>
                                            <a href="#"><i className="ri-inbox-archive-fill me-3 align-middle fw-medium" /> <span className="mail-list-link">Inbox</span> <span className="badge bg-success-subtle text-success ms-auto  ">5</span></a>
                                            <a href="#"><i className="ri-send-plane-2-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Sent</span></a>
                                            <a href="#"><i className="ri-edit-2-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Draft</span></a>
                                            <a href="#"><i className="ri-error-warning-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Spam</span></a>
                                            <a href="#"><i className="ri-delete-bin-5-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Trash</span></a>
                                            <a href="#"><i className="ri-star-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Starred</span></a>
                                            <a href="#"><i className="ri-price-tag-3-fill me-3 align-middle fw-medium" /><span className="mail-list-link">Important</span></a>
                                        </div>
                                        <div>
                                            <h5 className="fs-12 text-uppercase text-muted mt-4">Labels</h5>
                                            <div className="mail-list mt-1">
                                            <a href="#"><span className="ri-checkbox-blank-circle-line me-2 text-info" /><span className="mail-list-link" data-type="label">Support</span> <span className="badge bg-success-subtle text-success ms-auto">3</span></a>
                                            <a href="#"><span className="ri-checkbox-blank-circle-line me-2 text-warning" /><span className="mail-list-link" data-type="label">Freelance</span></a>
                                            <a href="#"><span className="ri-checkbox-blank-circle-line me-2 text-primary" /><span className="mail-list-link" data-type="label">Social</span></a>
                                            <a href="#"><span className="ri-checkbox-blank-circle-line me-2 text-danger" /><span className="mail-list-link" data-type="label">Friends</span><span className="badge bg-success-subtle text-success ms-auto">2</span></a>
                                            <a href="#"><span className="ri-checkbox-blank-circle-line me-2 text-success" /><span className="mail-list-link" data-type="label">Family</span></a>
                                            </div>
                                        </div>
                                        <div className="border-top border-top-dashed pt-3 mt-3">
                                            <a href="#" className="btn btn-icon btn-sm btn-soft-info rounded-pill float-end"><i className="bx bx-plus fs-16" /></a>
                                            <h5 className="fs-12 text-uppercase text-muted mb-3">Chat</h5>
                                            <div className="mt-2 vstack email-chat-list mx-n4">
                                            <a href="javascript: void(0);" className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2 avatar-xxs chatlist-user-image">
                                                <img className="img-fluid rounded-circle" src="assets/images/users/avatar-2.jpg" alt />
                                                </div>
                                                <div className="flex-grow-1 chat-user-box overflow-hidden">
                                                <h5 className="fs-13 text-truncate mb-0 chatlist-user-name">Scott Median</h5>
                                                <small className="text-muted text-truncate mb-0">Hello ! are you there?</small>
                                                </div>
                                            </a>
                                            <a href="javascript: void(0);" className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2 avatar-xxs chatlist-user-image">
                                                <img className="img-fluid rounded-circle" src="assets/images/users/avatar-4.jpg" alt />
                                                </div>
                                                <div className="flex-grow-1 chat-user-box overflow-hidden">
                                                <h5 className="fs-13 text-truncate mb-0 chatlist-user-name">Julian Rosa</h5>
                                                <small className="text-muted text-truncate mb-0">What about our next..</small>
                                                </div>
                                            </a>
                                            <a href="javascript: void(0);" className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2 avatar-xxs chatlist-user-image">
                                                <img className="img-fluid rounded-circle" src="assets/images/users/avatar-3.jpg" alt />
                                                </div>
                                                <div className="flex-grow-1 chat-user-box overflow-hidden">
                                                <h5 className="fs-13 text-truncate mb-0 chatlist-user-name">David Medina</h5>
                                                <small className="text-muted text-truncate mb-0">Yeah everything is fine</small>
                                                </div>
                                            </a>
                                            <a href="javascript: void(0);" className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2 avatar-xxs chatlist-user-image">
                                                <img className="img-fluid rounded-circle" src="assets/images/users/avatar-5.jpg" alt />
                                                </div>
                                                <div className="flex-grow-1 chat-user-box overflow-hidden">
                                                <h5 className="fs-13 text-truncate mb-0 chatlist-user-name">Jay Baker</h5>
                                                <small className="text-muted text-truncate mb-0">Wow that's great</small>
                                                </div>
                                            </a>
                                            </div>
                                        </div>
                                        </div></div></div></div><div className="simplebar-placeholder" style={{width: 250, height: 723}} /></div><div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}><div className="simplebar-scrollbar" style={{width: 0, display: 'none'}} /></div><div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}><div className="simplebar-scrollbar" style={{height: 122, transform: 'translate3d(0px, 0px, 0px)', display: 'block'}} /></div></div>
                            <div className="mt-auto">
                                <h5 className="fs-13">1.75 GB of 10 GB used</h5>
                                <div className="progress progress-sm">
                                <div className="progress-bar bg-success" role="progressbar" style={{width: '25%'}} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100} />
                                </div>
                            </div>
                            </div>
                        </div>
                       
                        <div className="email-content">
                            <div className="p-4 pb-0">
                            <div className="border-bottom border-bottom-dashed">
                                <div className="row mt-n2 mb-3 mb-sm-0">
                                <div className="col col-sm-auto order-1 d-block d-lg-none">
                                    <button type="button" className="btn btn-soft-success btn-icon btn-sm fs-16 email-menu-btn">
                                    <i className="ri-menu-2-fill align-bottom" />
                                    </button>
                                </div>
                                <div className="col-sm order-3 order-sm-2">
                                    <div className="hstack gap-sm-1 align-items-center flex-wrap email-topbar-link">
                                    <div className="form-check fs-14 m-0">
                                        <input className="form-check-input" type="checkbox" defaultValue id="checkall" />
                                        <label className="form-check-label" htmlFor="checkall" />
                                    </div>
                                    <div id="email-topbar-actions">
                                        <div className="hstack gap-sm-1 align-items-center flex-wrap">
                                        <button type="button" className="btn btn-ghost-secondary btn-icon btn-sm fs-16" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Archive" data-bs-original-title="Archive">
                                            <i className="ri-inbox-archive-fill align-bottom" />
                                        </button>
                                        <button type="button" className="btn btn-ghost-secondary btn-icon btn-sm fs-16" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Report Spam" data-bs-original-title="Report Spam">
                                            <i className="ri-error-warning-fill align-bottom" />
                                        </button>
                                        <div data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" aria-label="Trash" data-bs-original-title="Trash">
                                            <button type="button" className="btn btn-ghost-secondary btn-icon btn-sm fs-16" data-bs-toggle="modal" data-bs-target="#removeItemModal">
                                            <i className="ri-delete-bin-5-fill align-bottom" />
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="vr align-self-center mx-2" />
                                    <div className="dropdown">
                                        <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="ri-price-tag-3-fill align-bottom" />
                                        </button>
                                        <div className="dropdown-menu">
                                        <a className="dropdown-item" href="#">Support</a>
                                        <a className="dropdown-item" href="#">Freelance</a>
                                        <a className="dropdown-item" href="#">Social</a>
                                        <a className="dropdown-item" href="#">Friends</a>
                                        <a className="dropdown-item" href="#">Family</a>
                                        </div>
                                    </div>
                                    <div className="dropdown">
                                        <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="ri-more-2-fill align-bottom" />
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="#" id="mark-all-read">Mark all as Read</a>
                                        </div>
                                    </div>
                                    <div className="alert alert-warning alert-dismissible unreadConversations-alert px-4 fade show " id="unreadConversations" role="alert">
                                        No Unread Conversations
                                    </div>
                                    </div>
                                </div>
                                <div className="col-auto order-2 order-sm-3">
                                    <div className="d-flex gap-sm-1 email-topbar-link">
                                    <button type="button" className="btn btn-ghost-secondary btn-icon btn-sm fs-16">
                                        <i className="ri-refresh-line align-bottom" />
                                    </button>
                                    <div className="dropdown">
                                        <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="ri-more-2-fill align-bottom" />
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="#">Mark as Unread</a>
                                        <a className="dropdown-item" href="#">Mark as Important</a>
                                        <a className="dropdown-item" href="#">Add to Tasks</a>
                                        <a className="dropdown-item" href="#">Add Star</a>
                                        <a className="dropdown-item" href="#">Mute</a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div className="row align-items-end mt-3">
                                <div className="col">
                                    <div id="mail-filter-navlist">
                                    <ul className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0" role="tablist">
                                        <li className="nav-item" role="presentation">
                                        <button className="nav-link fw-semibold active" id="pills-primary-tab" data-bs-toggle="pill" data-bs-target="#pills-primary" type="button" role="tab" aria-controls="pills-primary" aria-selected="true">
                                            <i className="ri-inbox-fill align-bottom d-inline-block" />
                                            <span className="ms-1 d-none d-sm-inline-block">Primary</span>
                                        </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                        <button className="nav-link fw-semibold" id="pills-social-tab" data-bs-toggle="pill" data-bs-target="#pills-social" type="button" role="tab" aria-controls="pills-social" aria-selected="false" tabIndex={-1}>
                                            <i className="ri-group-fill align-bottom d-inline-block" />
                                            <span className="ms-1 d-none d-sm-inline-block">Social</span>
                                        </button>
                                        </li>
                                        <li className="nav-item" role="presentation">
                                        <button className="nav-link fw-semibold" id="pills-promotions-tab" data-bs-toggle="pill" data-bs-target="#pills-promotions" type="button" role="tab" aria-controls="pills-promotions" aria-selected="false" tabIndex={-1}>
                                            <i className="ri-price-tag-3-fill align-bottom d-inline-block" />
                                            <span className="ms-1 d-none d-sm-inline-block">Promotions</span>
                                        </button>
                                        </li>
                                    </ul>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="text-muted mb-2">1-50 of 154</div>
                                </div>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="pills-primary" role="tabpanel" aria-labelledby="pills-primary-tab">
                                <div className="message-list-content mx-n4 px-4 message-list-scroll">
                                    <div id="elmLoader">
                                    <div className="spinner-border text-primary avatar-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    </div>
                                    <ul className="message-list" id="mail-list" />
                                </div>
                                </div>
                                <div className="tab-pane fade" id="pills-social" role="tabpanel" aria-labelledby="pills-social-tab">
                                <div className="message-list-content mx-n4 px-4 message-list-scroll">
                                    <ul className="message-list" id="social-mail-list" />
                                </div>
                                </div>
                                <div className="tab-pane fade" id="pills-promotions" role="tabpanel" aria-labelledby="pills-promotions-tab">
                                <div className="message-list-content mx-n4 px-4 message-list-scroll">
                                    <ul className="message-list" id="promotions-mail-list" />
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                       
                        <div className="email-detail-content">
                            <div className="p-4 d-flex flex-column h-100">
                            <div className="pb-4 border-bottom border-bottom-dashed">
                                <div className="row">
                                <div className="col">
                                    <div className>
                                    <button type="button" className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-email" id="close-btn-email">
                                        <i className="ri-close-fill align-bottom" />
                                    </button>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <div className="hstack gap-sm-1 align-items-center flex-wrap email-topbar-link">
                                    <button type="button" className="btn btn-ghost-warning btn-icon btn-sm fs-16 favourite-btn active">
                                        <i className="ri-star-fill align-bottom" />
                                    </button>
                                    <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16">
                                        <i className="ri-printer-fill align-bottom" />
                                    </button>
                                    <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16 remove-mail" data-remove-id data-bs-toggle="modal" data-bs-target="#removeItemModal">
                                        <i className="ri-delete-bin-5-fill align-bottom" />
                                    </button>
                                    <div className="dropdown">
                                        <button className="btn btn-ghost-secondary btn-icon btn-sm fs-16" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="ri-more-2-fill align-bottom" />
                                        </button>
                                        <div className="dropdown-menu dropdown-menu-end">
                                        <a className="dropdown-item" href="#">Mark as Unread</a>
                                        <a className="dropdown-item" href="#">Mark as Important</a>
                                        <a className="dropdown-item" href="#">Add to Tasks</a>
                                        <a className="dropdown-item" href="#">Add Star</a>
                                        <a className="dropdown-item" href="#">Mute</a>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div className="mx-n4 px-4 email-detail-content-scroll simplebar-scrollable-y" data-simplebar="init"><div className="simplebar-wrapper" style={{margin: '0px -24px'}}><div className="simplebar-height-auto-observer-wrapper"><div className="simplebar-height-auto-observer" /></div><div className="simplebar-mask"><div className="simplebar-offset" style={{right: 0, bottom: 0}}><div className="simplebar-content-wrapper" tabIndex={0} role="region" aria-label="scrollable content" style={{height: '100%', overflow: 'hidden scroll'}}><div className="simplebar-content" style={{padding: '0px 24px'}}>
                                        <div className="mt-4 mb-3">
                                            <h5 className="fw-bold email-subject-title">New updates for Skote Theme</h5>
                                        </div>
                                        <div className="accordion accordion-flush">
                                            <div className="accordion-item border-dashed left">
                                            <div className="accordion-header">
                                                <a role="button" className="btn w-100 text-start px-0 bg-transparent shadow-none collapsed" data-bs-toggle="collapse" href="#email-collapseOne" aria-expanded="true" aria-controls="email-collapseOne">
                                                <div className="d-flex align-items-center text-muted">
                                                    <div className="flex-shrink-0 avatar-xs me-3">
                                                    <img src="assets/images/users/avatar-3.jpg" alt className="img-fluid rounded-circle" />
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="fs-14 text-truncate email-user-name mb-0">Jack Davis</h5>
                                                    <div className="text-truncate fs-12">to: me</div>
                                                    </div>
                                                    <div className="flex-shrink-0 align-self-start">
                                                    <div className="text-muted fs-12">09 Jan 2022, 11:12 AM</div>
                                                    </div>
                                                </div>
                                                </a>
                                            </div>
                                            <div id="email-collapseOne" className="accordion-collapse collapse">
                                                <div className="accordion-body text-body px-0">
                                                <div>
                                                    <p>Hi,</p>
                                                    <p>Praesent dui ex, dapibus eget mauris ut, finibus vestibulum enim. Quisque arcu leo, facilisis in fringilla id, luctus in tortor.</p>
                                                    <p>Sed elementum turpis eu lorem interdum, sed porttitor eros commodo. Nam eu venenatis tortor, id lacinia diam. Sed aliquam in dui et porta. Sed bibendum orci non tincidunt ultrices.</p>
                                                    <p>Sincerly,</p>
                                                    <div className="d-flex gap-3">
                                                    <div className="border rounded avatar-xl h-auto">
                                                        <img src="assets/images/small/img-2.jpg" alt className="img-fluid rouned-top" />
                                                        <div className="py-2 text-center">
                                                        <a href className="d-block fw-semibold">Download</a>
                                                        </div>
                                                    </div>
                                                    <div className="border rounded avatar-xl h-auto">
                                                        <img src="assets/images/small/img-6.jpg" alt className="img-fluid rouned-top" />
                                                        <div className="py-2 text-center">
                                                        <a href className="d-block fw-semibold">Download</a>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                         
                                            <div className="accordion-item border-dashed right">
                                            <div className="accordion-header">
                                                <a role="button" className="btn w-100 text-start px-0 bg-transparent shadow-none collapsed" data-bs-toggle="collapse" href="#email-collapseTwo" aria-expanded="true" aria-controls="email-collapseTwo">
                                                <div className="d-flex align-items-center text-muted">
                                                    <div className="flex-shrink-0 avatar-xs me-3">
                                                    <img src="assets/images/users/avatar-1.jpg" alt className="img-fluid rounded-circle" />
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="fs-14 text-truncate email-user-name-right mb-0">Anna Adame</h5>
                                                    <div className="text-truncate fs-12">to: jackdavis@email.com</div>
                                                    </div>
                                                    <div className="flex-shrink-0 align-self-start">
                                                    <div className="text-muted fs-12">09 Jan 2022, 02:15 PM</div>
                                                    </div>
                                                </div>
                                                </a>
                                            </div>
                                            <div id="email-collapseTwo" className="accordion-collapse collapse">
                                                <div className="accordion-body text-body px-0">
                                                <div>
                                                    <p>Hi,</p>
                                                    <p>If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual.</p>
                                                    <p>Thank you</p>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                    
                                            <div className="accordion-item border-dashed left">
                                            <div className="accordion-header">
                                                <a role="button" className="btn w-100 text-start px-0 bg-transparent shadow-none" data-bs-toggle="collapse" href="#email-collapseThree" aria-expanded="true" aria-controls="email-collapseThree">
                                                <div className="d-flex align-items-center text-muted">
                                                    <div className="flex-shrink-0 avatar-xs me-3">
                                                    <img src="assets/images/users/avatar-3.jpg" alt className="img-fluid rounded-circle" />
                                                    </div>
                                                    <div className="flex-grow-1 overflow-hidden">
                                                    <h5 className="fs-14 text-truncate email-user-name mb-0">Jack Davis</h5>
                                                    <div className="text-truncate fs-12">to: me</div>
                                                    </div>
                                                    <div className="flex-shrink-0 align-self-start">
                                                    <div className="text-muted fs-12">10 Jan 2022, 10:08 AM</div>
                                                    </div>
                                                </div>
                                                </a>
                                            </div>
                                            <div id="email-collapseThree" className="accordion-collapse collapse show">
                                                <div className="accordion-body text-body px-0">
                                                <div>
                                                    <p>Hi,</p>
                                                    <p>Everyone realizes why a new common language would be desirable: one could refuse to pay expensive translators. To achieve this, it would be necessary to have uniform grammar pronunciation.</p>
                                                    <p>Thank you</p>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                       
                                        </div>
                                       
                             </div></div></div></div><div className="simplebar-placeholder" style={{width: 398, height: 425}} /></div><div className="simplebar-track simplebar-horizontal" style={{visibility: 'hidden'}}><div className="simplebar-scrollbar" style={{width: 0, display: 'none'}} /></div><div className="simplebar-track simplebar-vertical" style={{visibility: 'visible'}}><div className="simplebar-scrollbar" style={{height: 265, transform: 'translate3d(0px, 0px, 0px)', display: 'block'}} /></div></div>
                            <div className="mt-auto">
                                <form className="mt-2">
                                <div>
                                    <label htmlFor="exampleFormControlTextarea1" className="form-label">Reply :</label>
                                    <textarea className="form-control border-bottom-0 rounded-top rounded-0 border" id="exampleFormControlTextarea1" rows={3} placeholder="Enter message" defaultValue={""} />
                                    <div className="bg-light px-2 py-1 rouned-bottom border">
                                    <div className="row">
                                        <div className="col">
                                        <div className="btn-group" role="group">
                                            <button type="button" className="btn btn-sm py-0 fs-15 btn-light" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Bold" data-bs-original-title="Bold"><i className="ri-bold align-bottom" /></button>
                                            <button type="button" className="btn btn-sm py-0 fs-15 btn-light" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Italic" data-bs-original-title="Italic"><i className="ri-italic align-bottom" /></button>
                                            <button type="button" className="btn btn-sm py-0 fs-15 btn-light" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Link" data-bs-original-title="Link"><i className="ri-link align-bottom" /></button>
                                            <button type="button" className="btn btn-sm py-0 fs-15 btn-light" data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Image" data-bs-original-title="Image"><i className="ri-image-2-line align-bottom" /></button>
                                        </div>
                                        </div>
                                        <div className="col-auto">
                                        <div className="btn-group">
                                            <button type="button" className="btn btn-sm btn-success"><i className="ri-send-plane-2-fill align-bottom" /></button>
                                            <button type="button" className="btn btn-sm btn-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="visually-hidden">Toggle Dropdown</span>
                                            </button>
                                            <ul className="dropdown-menu dropdown-menu-end">
                                            <li><a className="dropdown-item" href="#"><i className="ri-timer-line text-muted me-1 align-bottom" /> Schedule Send</a></li>
                                            </ul>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </form>
                            </div>
                            </div>
                        </div>
                      
                    </div> */}

                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "90vh" }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GeneralSettings;
